interface RgbType {
  r: number;
  g: number;
  b: number;
}

const rgbToYIQ = ({ r, g, b }: RgbType): number => {
  return (r * 299 + g * 587 + b * 114) / 1000;
};

const hexToRgb = (hex: string | undefined): RgbType | undefined => {
  if (!hex || hex === undefined || hex === '') {
    return undefined;
  }

  const result: RegExpExecArray | null = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined;
};

const getFontColorByPrimaryColor = (color: string | undefined, threshold = 128): string => {
  if (color === undefined) {
    return '#000';
  }
  const rgb: RgbType | undefined = hexToRgb(color);

  if (rgb === undefined) {
    return '#000';
  }

  return rgbToYIQ(rgb) >= threshold ? '#000' : '#fff';
};

export { getFontColorByPrimaryColor };
